<template>
    <v-expansion-panels flat class="table-filters">
        <v-expansion-panel>
            <v-expansion-panel-header class="py-2">
                <div class="d-flex align-center">
                    <v-icon small class="mr-2">mdi-filter-variant</v-icon>
                    <span class="text-subtitle-2">Filters</span>
                    <v-chip v-if="activeCount" class="ml-2" x-small dark color="primary">{{ activeCount }} active</v-chip>
                </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
                <v-row align="center" dense>
                    <v-col
                        v-for="field in fields"
                        :key="field.key"
                        cols="12"
                        sm="6"
                        lg="3"
                    >
                        <v-autocomplete
                            v-if="field.type === 'autocomplete'"
                            v-model="localValues[field.key]"
                            :items="options[field.key] || []"
                            :item-text="field.itemText || 'name'"
                            :item-value="field.itemValue || 'id'"
                            :label="field.label"
                            menu-props="auto"
                            outlined
                            dense
                            hide-details
                            clearable
                        />
                        <v-select
                            v-else-if="field.type === 'select' || field.type === 'boolean'"
                            v-model="localValues[field.key]"
                            :items="field.type === 'boolean' ? booleanItems : field.items"
                            :label="field.label"
                            menu-props="auto"
                            outlined
                            dense
                            hide-details
                            clearable
                        />
                        <v-menu
                            v-else-if="field.type === 'dateRange'"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    :value="formatRange(localValues[field.key])"
                                    :label="field.label"
                                    prepend-inner-icon="mdi-calendar"
                                    readonly
                                    outlined
                                    dense
                                    hide-details
                                    clearable
                                    v-bind="attrs"
                                    v-on="on"
                                    @click:clear="localValues[field.key] = null"
                                />
                            </template>
                            <v-date-picker
                                v-model="localValues[field.key]"
                                range
                                no-title
                            />
                        </v-menu>
                        <v-text-field
                            v-else
                            v-model="localValues[field.key]"
                            :type="field.type === 'number' ? 'number' : 'text'"
                            :label="field.label"
                            :prepend-inner-icon="field.type === 'number' ? null : 'mdi-magnify'"
                            outlined
                            dense
                            hide-details
                            clearable
                            @keyup.enter="applyFilters"
                        />
                    </v-col>
                    <v-col cols="12" class="d-flex justify-end pt-3">
                        <v-btn class="mr-2" text small @click="clearFilters">
                            <v-icon left small>mdi-close</v-icon>Clear
                        </v-btn>
                        <v-btn class="white--text" depressed small color="black" @click="applyFilters">
                            <v-icon left small>mdi-filter</v-icon>Apply
                        </v-btn>
                    </v-col>
                </v-row>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script>
    import momentTimezone from 'moment-timezone'

    // fields: [{ key, label, type: 'text' | 'number' | 'boolean' | 'select' | 'autocomplete' | 'dateRange',
    //            items (select), loadItems () => Promise<Array> (autocomplete), itemText, itemValue, default }]
    export default {
        name: 'TableFilters',
        props: {
            fields: {
                type: Array,
                required: true
            },
            value: {
                type: Object,
                default: () => ({})
            }
        },
        data: () => {
            return {
                localValues: {},
                options: {},
                booleanItems: [
                    { text: 'Yes', value: true },
                    { text: 'No', value: false }
                ]
            }
        },
        computed: {
            activeCount() {
                return this.fields.filter(field => {
                    const value = this.value[field.key]
                    return value !== null && value !== undefined && value !== '' && !(Array.isArray(value) && !value.length)
                }).length
            }
        },
        watch: {
            value: {
                handler() {
                    this.syncLocalValues()
                },
                immediate: true
            }
        },
        created() {
            this.fields.filter(field => field.loadItems).forEach(field => {
                field.loadItems().then(items => {
                    this.$set(this.options, field.key, items)
                })
            })
        },
        methods: {
            syncLocalValues() {
                this.localValues = this.fields.reduce((values, field) => {
                    const value = this.value[field.key]
                    values[field.key] = value === undefined ? null : value
                    return values
                }, {})
            },
            formatRange(range) {
                if (!range || !range.length) {
                    return ''
                }
                return [...range].sort().map(date => momentTimezone(date).format('DD/MM/YYYY')).join(' - ')
            },
            clearFilters() {
                this.$emit('apply', this.fields.reduce((values, field) => {
                    values[field.key] = null
                    return values
                }, {}))
            },
            applyFilters() {
                this.$emit('apply', { ...this.localValues })
            }
        }
    }
</script>

<style scoped>
    .table-filters ::v-deep .v-expansion-panel-header {
        min-height: 44px;
    }

    .table-filters ::v-deep .v-expansion-panel-content__wrap {
        padding-bottom: 12px;
    }
</style>
